import '../styles/globals.css';
import GoogleAnalyticsScript from "../components/google/googleAnalyticsScript";
import Head from 'next/head';
import React, { Component } from "react";


class MyApp extends Component
{
    constructor(props)
    {
        super(props)
    }

    render()
    {
        const { Component, pageProps } = this.props;

        return (
            <>
                <Head>
                    <title>solvar.com.au</title>
                    <link rel="shortcut icon" href="/favicon.ico" />
                    <link href="/favicon_128.png" rel="apple-touch-icon" />
                    <link href="/favicon_152.png" rel="apple-touch-icon" sizes="152x152" />
                    <link href="/favicon_167.png" rel="apple-touch-icon" sizes="167x167" />
                    <link href="/favicon_180.png" rel="apple-touch-icon" sizes="180x180" />
                    <link href="/favicon_192.png" rel="icon" sizes="192x192" />
                    <link href="/favicon_128.png" rel="icon" sizes="128x128" />
                    <meta name="description" content="Solvar Limited investors information website. View company announcements, ASX SVR share price, shareholder information and annual reports."></meta>
                </Head>
                <GoogleAnalyticsScript />
                <Component {...pageProps} />
            </>
        );
    }
}

export default MyApp;